<template>
  <div :class="className" :id="id" :style="{height:height,width:width}" ref="myEchart"></div>
</template>
<script>
import echarts from 'echarts'
export default {
  name: 'PieChartComponent',
  props: {
    className: {
      type: String,
      default: 'yourClassName'
    },
    id: {
      type: String,
      default: 'yourID'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '250px'
    },
    option: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      /* defaultOption: {
        title: {
          text: '全部日程统计',
          top: '45%',
          left: '21%',
          textStyle: {
            fontWeight: 'normal',
            fontSize: 14,
            fontFamily: 'PingFangSC'
          }
        },
        legend: {
          orient: 'vertical',
          top: '20%',
          right: '4%',
          icon: 'circle',
          data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
        },
        series: []
      } */
    }
  },
  computed: {
    /* lastOption () {
      return Object.assign({}, this.defaultOption, this.option)
    } */
  },
  methods: {
    initChart () {
      console.log('initChart1sfasd1')
      this.chart = echarts.init(this.$refs.myEchart)
      // 把配置和数据放这里
      // console.log(Object.assign({}, this.defaultOption, this.option))
      this.chart.setOption(this.option)
    }
  },
  watch: {
    option: function (newVal, oldVal) {
      this.initChart()
      this.chart.resize()
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pagesPc/others/pieChartComponent.vue